import ArticleCategoryPage from './ArticleCategoryPage';
export default ArticleCategoryPage;